import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "dt-previewCard__wrapperElements dt-previewCard__info-tagList"
}
const _hoisted_2 = {
  key: 0,
  class: "dt-previewCard__info-tag"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 2,
  class: "dt-previewCard__wrapperElements dt-previewCard__info-description"
}
const _hoisted_5 = {
  key: 3,
  class: "dt-previewCard__wrapperElements dt-previewCard__info-address"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.0803 8.90916C12.7774 7.688 13 6.94194 13 6.66667C13 5.68803 12.5229 4.48823 11.626 3.51561C10.7412 2.55625 9.61969 2 8.5 2C7.38031 2 6.25878 2.55625 5.37404 3.51561C4.47706 4.48823 4 5.68803 4 6.66667C4 6.94194 4.22263 7.688 4.91968 8.90916C5.55791 10.0273 6.41872 11.2502 7.27164 12.3673C7.89297 13.1811 8.23147 13.6143 8.5 13.8754C8.76853 13.6143 9.10703 13.1811 9.72836 12.3673C10.5813 11.2502 11.4421 10.0273 12.0803 8.90916ZM11.318 13.581C13.0734 11.2819 15 8.37051 15 6.66667C15 3.53705 12.0899 0 8.5 0C4.91015 0 2 3.53705 2 6.66667C2 8.37051 3.9266 11.2819 5.68202 13.581C6.90116 15.1777 7.51073 15.9761 8.5 15.9761C9.48927 15.9761 10.0988 15.1777 11.318 13.581Z"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M9.99991 6.5C9.99991 7.32843 9.32834 8 8.49991 8C7.67149 8 6.99991 7.32843 6.99991 6.5C6.99991 5.67157 7.67149 5 8.49991 5C9.32834 5 9.99991 5.67157 9.99991 6.5Z" })
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fpg_nav = _resolveComponent("fpg-nav")!

  return ($props.element['@type'] === 'title')
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: $props.item.getUrl(),
        class: "dt-previewCard__info-title"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.element.value), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"]))
    : ($props.element['@type'] === 'tags')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.element.tags, (tag) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (tag['@type'] === 'tag')
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    ($props.element.useRefForFilter === true)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: ($event: any) => ($options.onApplyFilterByTag(tag)),
                          style: _normalizeStyle({
                                color: $props.element.defaultColor !== true && tag.color !== null ? tag.color : null,
                            }),
                          class: _normalizeClass({
                                'square': $props.element.style.viewMode === 'square',
                                'round': $props.element.style.viewMode === 'round',
                            })
                        }, [
                          _createElementVNode("span", null, _toDisplayString(tag.value), 1 /* TEXT */),
                          ($props.element.style.viewMode != 'default')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "dt-previewCard__info-tag-bg",
                                style: _normalizeStyle({
                                    background: $props.element.defaultColor !== true && tag.color !== null ? tag.color : null,
                                })
                              }, null, 4 /* STYLE */))
                            : _createCommentVNode("v-if", true)
                        ], 14 /* CLASS, STYLE, PROPS */, _hoisted_3))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          style: _normalizeStyle({
                                color: $props.element.defaultColor !== true && tag.color !== null ? tag.color : null,
                            }),
                          class: _normalizeClass({
                                'square': $props.element.style.viewMode === 'square',
                                'round': $props.element.style.viewMode === 'round',
                            })
                        }, [
                          _createElementVNode("span", null, _toDisplayString(tag.value), 1 /* TEXT */),
                          ($props.element.style.viewMode != 'default')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "dt-previewCard__info-tag-bg",
                                style: _normalizeStyle({
                                    background: $props.element.defaultColor !== true && tag.color !== null ? tag.color : null,
                                })
                              }, null, 4 /* STYLE */))
                            : _createCommentVNode("v-if", true)
                        ], 6 /* CLASS, STYLE */))
                  ]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]))
      : ($props.element['@type'] === 'description')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($props.element.value), 1 /* TEXT */))
        : ($props.element['@type'] === 'address')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString($props.element.value.address), 1 /* TEXT */)
            ]))
          : ($props.element['@type'] === 'button')
            ? (_openBlock(), _createBlock(_component_fpg_nav, {
                key: 4,
                element: $props.element,
                item: $props.item,
                buttonBlock: $props.buttonBlock
              }, null, 8 /* PROPS */, ["element", "item", "buttonBlock"]))
            : _createCommentVNode("v-if", true)
}